import React, { useEffect, useState } from "react";
import Table from "@/common/elements/Table";
import { StyledSectionHeading } from "@/common/styles";
import { labels } from "@/util/label";
import { useFilterSearchContext } from "@/contexts/FolderSearchContext";
import API_ENDPOINTS, { PHOTOS_BASE_URL } from "@/util/api";
import { toQueryString, isNonEmptyVariable } from "@/util/common_function";
import api from "@/services/axios_custom";
import axios from "axios";
import DataTable from "@/common/elements/DataTable";

const FolderDataTable = ({ onRowClick }) => {
  const { requestFilter } = useFilterSearchContext();

  const [folderSearchData, setFolderSearchData] = useState({
    total: 0,
    headers: [
      { key: "folderId", text: labels.jacketID },
      { key: "numBookings", text: "B" },
      { key: "numCivil", text: "C" },
      { key: "numWarrants", text: "W" },
      { key: "score", text: "Score" },
      { key: "aliases", text: "Aliases" },
      { key: "lName", text: labels.lastName },
      { key: "fName", text: labels.firstName },
      { key: "mName", text: labels.middleName },
      { key: "suffix", text: labels.suffix },
      { key: "race", text: labels.race },
      { key: "sex", text: labels.gender },
      { key: "dob", text: labels.dob },
      { key: "ssn", text: labels.ssn },
      { key: "street1", text: labels.street1 },
    ],
    rows: [],
  });

  // Local pagination and loading state.
  const [pagination, setPagination] = useState({ pageIndex: 0, pageSize: 10 });
  const [isAPICallLoading, setIsAPICallLoading] = useState(false);

  // API call: Uses requestFilter from context and pagination from local state.
  const getFolderSearchData = () => {
    const dataToSend = JSON.stringify(requestFilter);
    let url = API_ENDPOINTS.folderSearch;
    const queryObj = { page: pagination.pageIndex, size: pagination.pageSize };
    const urlParam = toQueryString(queryObj);
    if (isNonEmptyVariable(urlParam)) {
      url += "?" + urlParam;
    }
    setIsAPICallLoading(true);
    api
      .post(url, dataToSend)
      .then((response) => {
        const { total, rows } = response?.data;
        const capitalize = (str) =>
          str && str.charAt(0).toUpperCase() + str.slice(1);

        // Transform the nested payload into flat row objects.
        const transformedRows = rows?.map((jsd) => {
          const aliasesData = jsd?.jackets?.bio?.[0]?.bioAliases?.[0];
          return {
            folderId: jsd?.jacketId,
            numBookings: jsd?.bioSearchResponse?.numBookings,
            numCivil: jsd?.bioSearchResponse?.numCivil,
            numWarrants: jsd?.bioSearchResponse?.numWarrants,
            score: jsd?.bioSearchResponse?.score,
            aliases:
              typeof aliasesData !== "undefined"
                ? `${aliasesData.lName} ${aliasesData.fName} ${aliasesData.mName}`
                : "",
            lName: capitalize(jsd?.jackets?.bio?.[0]?.lName || ""),
            fName: capitalize(jsd?.jackets?.bio?.[0]?.fName || ""),
            mName: capitalize(jsd?.jackets?.bio?.[0]?.mName || ""),
            suffix: jsd?.jackets?.bio?.[0]?.suffix,
            race: jsd?.jackets?.bio?.[0]?.race,
            sex: jsd?.jackets?.bio?.[0]?.sex,
            dob: jsd?.jackets?.bio?.[0]?.dob,
            ssn: jsd?.jackets?.bio?.[0]?.ssn,
            street1: jsd?.jackets?.bio?.[0]?.street1,
            // Preserve original data for further usage.
            originalData: jsd,
            photos: jsd?.jackets?.bio?.[0]?.bioPhotos,
          };
        });

        setFolderSearchData((prev) => ({
          ...prev,
          total: total,
          rows: transformedRows,
        }));
      })
      .catch((error) => {
        if (!axios.isCancel(error)) {
          console.error("Error fetching folder data:", error);
        }
      })
      .finally(() => {
        setIsAPICallLoading(false);
      });
  };

  // Trigger API call whenever the requestFilter or pagination changes.
  useEffect(() => {
    getFolderSearchData();
  }, [requestFilter, pagination]);

  return (
    <>
      <StyledSectionHeading>
        <span>List of Folders</span>
      </StyledSectionHeading>
      <DataTable
        rowUniqueId="folderId"
        allowTableSorting={true}
        headers={folderSearchData.headers}
        data={folderSearchData.rows}
        onRowClick={onRowClick}
        isAPiCallLoading={isAPICallLoading}
        totalRecords={folderSearchData.total}
        pagination={pagination}
        setPagination={setPagination}
      />
    </>
  );
};

export default FolderDataTable;
